<template>
  <section style="width: 100%;">
    <app-container-loading
      :show="isLoading"
      :text="'Criando empresa...'"
    ></app-container-loading>
    <section class="create-companies__main-area">
      <div
        style="display: flex; flex-direction: column; justify-content: space-between; height: 100%;"
      >
        <div style="display: flex; justify-content: space-between;">
          <div class="column">
            <div class="header">
              <router-link
                to="/master/companies"
                exact
                tag="li"
                :title="'Empresas'"
                v-tippy="{
                  placement: 'right',
                  theme: 'light',
                  inertia: true,
                  arrow: true,
                  animation: 'perspective',
                }"
                class="box-add-icon"
              >
                <fa size="lg" icon="arrow-left" />
              </router-link>
            </div>
            CRIAR EMPRESA
            <div class="content-column">
              <div class="section-items">
                <div style="margin-right: 15px;">
                  Nome da empresa*
                  <input
                    type="text"
                    class="input input-config"
                    v-model="form.companyName"
                  />
                </div>
                <div style="width: 30%;">
                  CNPJ
                  <app-mask
                    :mask="['##.###.###/####-##']"
                    v-model="form.companyLegalDocument"
                    placeholder="##.###.###/####-##"
                    class="input input-config"
                  ></app-mask>
                </div>
              </div>
              <div class="section-items">
                <div style="margin-right: 15px;">
                  Nome do responsável*
                  <input
                    type="text"
                    class="input input-config"
                    v-model="form.name"
                  />
                </div>
                <div style="margin-right: 15px; width: 40%;">
                  Cel./tel. para contato*
                  <app-mask
                    :mask="['(##) ####-####', '(##) #####-####']"
                    v-model="form.companyPhoneNumber"
                    placeholder="(##) #####-####"
                    class="input input-config"
                  ></app-mask>
                </div>
                <div>
                  Email para entrar na conta*
                  <input
                    type="email"
                    class="input input-config"
                    v-model="form.email"
                  />
                </div>
              </div>
              <div class="section-items">
                <app-switch
                  class="switch-toggle"
                  v-model="form.isZepplin"
                  label="Criar empresa no Zepplin"
                />
              </div>
              <section
                v-if="form.isZepplin"
                class="column"
                style="margin-top: 20px;"
              >
                ZEPPLIN
                <div class="content-column">
                  <div class="section-items">
                    <div style="width: 30%; margin-right: 15px;">
                      Taxa dos pedidos (%)*
                      <input
                        type="text"
                        class="input input-config"
                        v-model="form.zepplinForm.companyTax.requestTax"
                      />
                    </div>
                    <div style="width: 40%; margin-right: 15px;">
                      Taxa do pagamento online (%)*
                      <input
                        type="text"
                        class="input input-config"
                        v-model="form.zepplinForm.companyTax.creditCardTax"
                      />
                    </div>
                    <div style="margin-right: 15px; margin-bottom: 10px;">
                      Categoria da empresa*
                      <app-select
                        :downIcon="true"
                        class="input input-config"
                        :items="getCompanyCategoriesList"
                        :popoverProps="{
                          verticalOffset: 0,
                          horizontalOffset: -15,
                          placement: 'bottom-start',
                        }"
                        @input="form.zepplinForm.companyCategoryId = $event"
                      >
                        <input
                          type="text"
                          class="select readonly"
                          style="margin-bottom: 0px; border: none; padding: 0"
                          readonly
                          :value="
                            getCompanyCategoryById(
                              form.zepplinForm.companyCategoryId
                            )
                              ? getCompanyCategoryById(
                                  form.zepplinForm.companyCategoryId
                                ).text
                              : 'Selecione'
                          "
                        />
                        <template slot="item" slot-scope="slotProps">
                          <span>{{ slotProps.text }}</span>
                        </template>
                      </app-select>
                    </div>
                    <div style="width: 40%;">
                      Cel./tel. da empresa
                      <app-mask
                        :mask="['(##) ####-####', '(##) #####-####']"
                        v-model="form.zepplinForm.zepplinCompanyPhoneNumber"
                        placeholder="(##) #####-####"
                        class="input input-config"
                      ></app-mask>
                    </div>
                  </div>
                  <div class="section-items">
                    <div style="margin-right: 15px; margin-bottom: 10px;">
                      Responsável pelas entrega*
                      <small>(pode ser alterado no painel da empresa)</small>
                      <app-select
                        :downIcon="true"
                        class="input input-config"
                        :items="getDeliveryCompaniesList"
                        :popoverProps="{
                          verticalOffset: 0,
                          horizontalOffset: -15,
                          placement: 'bottom-start',
                        }"
                        @input="form.zepplinForm.deliveryCompanyId = $event"
                      >
                        <input
                          type="text"
                          class="select readonly"
                          style="margin-bottom: 0; border: none; padding: 0;"
                          readonly
                          :value="
                            getDeliveryCompanyById(
                              form.zepplinForm.deliveryCompanyId
                            )
                              ? getDeliveryCompanyById(
                                  form.zepplinForm.deliveryCompanyId
                                ).text
                              : 'Selecione'
                          "
                        />
                        <template slot="item" slot-scope="slotProps">
                          <span>{{ slotProps.text }}</span>
                        </template>
                      </app-select>
                    </div>
                    <div style="width: 40%;">
                      Tempo de entrega padrão*
                      <input
                        type="text"
                        class="input input-config"
                        v-model="form.zepplinForm.defaultDeliveryTime"
                      />
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
        <div>
          <div style="float:right; width: 200px;">
            <a
              href="javascript:void(0)"
              class="btn button-gradient"
              style="float: right"
              @click="submit()"
            >
              Salvar alterações
            </a>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

import CompaniesAPI from "../../../api/companies";

export default {
  props: ["user"],
  data() {
    return {
      form: {
        companyName: "",
        companyLegalDocument: undefined,
        name: "",
        email: "",
        companyPhoneNumber: "",
        isZepplin: true,
        zepplinForm: {
          companyCategoryId: undefined,
          deliveryCompanyId: undefined,
          zepplinCompanyPhoneNumber: undefined,
          companyTax: {
            requestTax: 8,
            creditCardTax: 3.5,
          },
        },
      },
      isLoading: false,
    };
  },
  computed: {
    ...mapState("auth", ["zepplinMasterToken"]),
    ...mapGetters("zepplin/company-categories", [
      "getCompanyCategoriesList",
      "getCompanyCategoryById",
    ]),
    ...mapGetters("zepplin/delivery-companies", [
      "getDeliveryCompaniesList",
      "getDeliveryCompanyById",
    ]),
  },
  methods: {
    ...mapActions("toast", ["showToast", "showError"]),
    validateForm(form) {
      const messages = [];
      const defaultMessage = "É necessário informar";
      if (!form.companyName)
        messages.push(`${defaultMessage} nome da empresa.`);
      if (!form.name) messages.push(`${defaultMessage} nome do responsável.`);

      if (!form.email)
        messages.push(`${defaultMessage} email para entrar na conta.`);
      else if (!this.utils.validateEmail(form.email))
        messages.push("Endereço de email inválido.");

      if (form.legalDocument && !this.utils.validateCNPJ(form.legalDocument))
        messages.push("CNPJ inválido.");

      if (!form.companyPhoneNumber)
        messages.push(`${defaultMessage} telefone ou celular para contato.`);
      if (form.isZepplin) {
        const zepplinForm = form.zepplinForm;
        if (!zepplinForm.companyTax.requestTax)
          messages.push(`${defaultMessage} taxa de pedidos Zepplin (%).`);
        else if (Number.isNaN(parseFloat(zepplinForm.companyTax.requestTax)))
          messages.push(`Taxa zepplin precisa ser um número.`);
        if (!zepplinForm.companyTax.creditCardTax)
          messages.push(`${defaultMessage} taxa de pedidos Zepplin (%).`);
        else if (Number.isNaN(parseFloat(zepplinForm.companyTax.creditCardTax)))
          messages.push(`Taxa zepplin precisa ser um número.`);
        if (!zepplinForm.companyCategoryId)
          messages.push(`${defaultMessage} categoria da empresa.`);
        if (!zepplinForm.defaultDeliveryTime)
          messages.push(`${defaultMessage} um tempo de entrega padrão.`);
        else if (Number.isNaN(parseInt(zepplinForm.defaultDeliveryTime)))
          messages.push(`Tempo de entrega padrão precisa ser um número.`);
      }
      return messages;
    },

    async submit() {
      const errorMessages = this.validateForm(this.form);
      errorMessages.forEach((errorMessage) => {
        this.showError(errorMessage);
      });
      if (errorMessages.length) return;

      const toSend = this.utils.removeReactivity(this.form);
      if (toSend.isZepplin) {
        Object.assign(toSend, {
          ...toSend.zepplinForm,
        });
      }
      delete toSend.zepplinForm;
      Object.assign(toSend, {
        companyLegalDocument:
          typeof toSend.companyLegalDocument === "string" &&
          !toSend.companyLegalDocument.trim()
            ? null
            : toSend.companyLegalDocument,
        deliveryCompanyId:
          toSend.deliveryCompanyId &&
          this.utils.validateObjectId(toSend.deliveryCompanyId)
            ? toSend.deliveryCompanyId
            : undefined,
      });
      this.isLoading = true;
      try {
        await CompaniesAPI.createCompany(toSend, {
          masterToken: this.zepplinMasterToken,
        });
        this.showToast({
          type: "success",
          message: "Empresa criada com sucesso.",
        });
      } catch (err) {
        console.error(err);
        this.showError("Não foi possível criar empresa.");
      }
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
input {
  margin-bottom: 10px;
}

.input-config {
  border-bottom: 1px solid #525662;
  width: 100%;
}

.column {
  width: 100%;
  font-weight: 600;
}

.content-column {
  margin-top: 20px;
  width: 100%;

  div {
    width: 100%;
  }
}

.field {
  display: flex;
  justify-content: space-between;
}

.section-items {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.create-companies__main-area {
  width: 100%;
  background-color: var(--bg-color--2);
  padding: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.header {
  margin-bottom: 20px;
}
</style>
